import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huanyihuan",
  "use": "icon-huanyihuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-huanyihuan\"><path d=\"M839.400727 723.269818l159.464728-233.378909h-112.779637a437.527273 437.527273 0 1 0-152.157091 362.123636l-58.461091-75.496727a342.946909 342.946909 0 1 1 115.246546-286.626909h-110.592l159.464727 233.378909z\" p-id=\"1397\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol